import React, {Component} from "react";
import {Col} from "reactstrap";
import PropTypes from "prop-types";
import SearchIcon from "./img/search.svg"
import {Calculator} from "./Calculator";
import {Strings} from "./Strings";

export class ProductFinder extends Component {
    constructor(props) {
        super(props);
        this.productFinders = [
            ["https://www.avkvalves.eu/en/product-finder/control-valves/control-valves-pilot-operated/859-000X-001", "https://www.avkvalves.eu/en/product-finder/control-valves/control-valves-pilot-operated/859-100X-001"],
            ["https://www.avkuk.co.uk/en-gb/product-finder/pressure-and-flow-control-valves/control-valves-pilot-operated/859-020X-001", "https://www.avkuk.co.uk/en-gb/product-finder/pressure-and-flow-control-valves/control-valves-pilot-operated/859-120X-001 "],
            ["http://www.avkchina.com/en/products/productfinder/details?STVId=859/000X-001", "http://www.avkchina.com/en/products/productfinder/details?STVId=859/000X-001"],
            ["http://www.avkchina.com/en/products/productfinder/details?STVId=859/000X-001", "http://www.avkchina.com/en/products/productfinder/details?STVId=859/000X-001"],
        ];
    }

    render() {
        const location = this.props.location;
        const valveBore = this.props.inputData.valveBore;
        const link = this.productFinders[location][valveBore];
        const disabled = Calculator.shouldShowAntiCavitationMessage(this.props.inputData);
        const productFinderClass = (disabled ? ("productFinder-disabled") : ("productFinder"));
        return <Col md={this.props.md} className="d-flex flex-fill flex-column headerless botSpace">
            <a className="d-flex flex-fill" href={!disabled ? link : undefined}>
                <Col className={productFinderClass + " d-flex align-items-center justify-content-center"}>
                    <img src={SearchIcon} alt="" className="icon"/>
                    <h2 className={productFinderClass}>{Strings.titleProductFinder}</h2>
                </Col>
            </a></Col>
    }
}

ProductFinder.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired,
    location: PropTypes.number.isRequired
};